import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { getField } from 'apps/auth/components/form-multi/utils';
import { AUTH_PAY_STATUS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';

import PayPalButton from './PayPalButton';

const ButtonWrapper = styled.div`
    pointer-events: auto;

    .paypal-button {
        width: 260px;
    }
`;

const PayPalButtonWrapper = ({
    modalRef,
    payPalSdkParamsInit,
    precheck,
    popupRef = null,
    setPaymentParam,
    toggleSpinner,
    updateMessages,
    updatePageMessages,
}) => {
    const { paymentId = null, clientId = null, merchantId = null, disableFunding = null, enableFunding = null, commit = null } = payPalSdkParamsInit;
    const statusPageHref = `${AUTH_PAY_STATUS}?id=${paymentId}`;

    const createOrder = async () => {
        toggleSpinner(true);
        const fields = {};
        fields.id = getField('id', precheck.id);
        fields.acceptedPayment = getField('acceptedPayment', true);
        const orderId = await apiFetchData('/auth/send/pay.action', fields)
            .then((json) => {
                if (json?.messageBodyMessages) {
                    updateMessages(json.messageBodyMessages);
                }
                if (json.messages) {
                    updatePageMessages(json.messages);
                }
                if (json.extra?.iframeRedirectUrl) {
                    window.location.href = json.extra?.iframeRedirectUrl;
                } else if (json.redirectTo) {
                    window.location.href = json.redirectTo;
                } else if (json.payPalAccountBean?.checkoutPaymentOrderId) {
                    return json.payPalAccountBean?.checkoutPaymentOrderId;
                }
            })
            .finally(() => toggleSpinner(false))
            .catch((e) => logWarn(e));
        const paymentParam = setPaymentParam();
        sessionStorage?.setItem(precheck?.id, paymentParam);
        return orderId;
    };

    const style = {
        height: 55,
        shape: 'pill',
        label: 'pay',
    };

    return (
        <ButtonWrapper>
            <PayPalScriptProvider
                options={{
                    clientId,
                    currency: precheck?.amountFromCurrency,
                    merchantId,
                    disableFunding,
                    enableFunding,
                    commit,
                }}
            >
                <PayPalButton
                    className={'paypal-button'}
                    createOrder={createOrder}
                    style={style}
                    modalRef={modalRef}
                    popupRef={popupRef}
                    statusPageHref={statusPageHref}
                />
            </PayPalScriptProvider>
        </ButtonWrapper>
    );
};
PayPalButtonWrapper.propTypes = {
    payPalSdkParamsInit: PropTypes.object.isRequired,
    modalRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    precheck: PropTypes.object.isRequired,
    setPaymentParam: PropTypes.func,
    toggleSpinner: PropTypes.func.isRequired,
    updateMessages: PropTypes.func.isRequired,
    updatePageMessages: PropTypes.func.isRequired,
    deliveryMethodId: PropTypes.string.isRequired,
    sourceFundingId: PropTypes.string.isRequired,
};

export default PayPalButtonWrapper;
